import styles from './styles.module.scss';

export const HotkeyHint = ({ hint, top, right }: { hint: string | number, top?: number, right?: number }) => {
  return <div className={styles.hint} style={{ top: top, right: right }}>{hint}</div>;
};
